import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { ALL_AUTHENTICATED_ROLES } from '@/shared/config/access-roles';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const MyFilesContainer = React.lazy(
  () => import('../../containers/my-files/my-files.container')
);

export const MyFilesRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="list" replace />
  },
  {
    path: 'list',
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={ALL_AUTHENTICATED_ROLES}
          component={MyFilesContainer}
        />
      </React.Suspense>
    )
  }
];
